// File: frontend/src/components/Leads/LeadFilters.jsx
// Lead filters component

import React from 'react';

// Devuelve el createdFrom (YYYY-MM-DD) para cada atajo. 'all' => '' (sin filtro).
const dateShortcutToCreatedFrom = (key) => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (key) {
    case 'today':
      return startOfToday.toISOString().slice(0, 10);
    case '7d': {
      const d = new Date(startOfToday); d.setDate(d.getDate() - 7);
      return d.toISOString().slice(0, 10);
    }
    case '30d': {
      const d = new Date(startOfToday); d.setDate(d.getDate() - 30);
      return d.toISOString().slice(0, 10);
    }
    case 'month':
      return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0, 10);
    default:
      return '';
  }
};

const DATE_SHORTCUTS = [
  { key: 'all', label: 'Tudo' },
  { key: 'today', label: 'Hoje' },
  { key: '7d', label: '7 dias' },
  { key: '30d', label: '30 dias' },
  { key: 'month', label: 'Este mês' },
];

const LeadFilters = ({ filters, onFilterChange, userRole }) => {
  const handleFilterChange = (field, value) => {
    onFilterChange({ [field]: value });
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {/* Lifecycle Stage */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Estágio do Lead
          </label>
          <select
            value={filters.lifecycleStage || ''}
            onChange={(e) => handleFilterChange('lifecycleStage', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="">Todos</option>
            <option value="subscriber">Subscriber</option>
            <option value="lead">Lead</option>
            <option value="mql">MQL</option>
            <option value="sql">SQL</option>
            <option value="customer">Customer</option>
          </select>
        </div>

        {/* Lead Status */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            value={filters.leadStatus || ''}
            onChange={(e) => handleFilterChange('leadStatus', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="">Todos</option>
            <option value="new">Novo</option>
            <option value="contacted">Contatado</option>
            <option value="qualified">Qualificado</option>
            <option value="nurturing">Nutrição</option>
            <option value="unqualified">Desqualificado</option>
          </select>
        </div>

        {/* Lead Score Range */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Score Mínimo
          </label>
          <input
            type="number"
            min="0"
            max="10"
            value={filters.minScore || ''}
            onChange={(e) => handleFilterChange('minScore', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="0-10"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Score Máximo
          </label>
          <input
            type="number"
            min="0"
            max="10"
            value={filters.maxScore || ''}
            onChange={(e) => handleFilterChange('maxScore', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="0-10"
          />
        </div>

        {/* Lead Source */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Fonte
          </label>
          <select
            value={filters.leadSource || ''}
            onChange={(e) => handleFilterChange('leadSource', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="">Todas</option>
            <option value="rd_station">RD Station</option>
            <option value="website">Website</option>
            <option value="social_media">Redes Sociais</option>
            <option value="referral">Indicação</option>
            <option value="cold_outreach">Prospecção Ativa</option>
            <option value="event">Evento</option>
            <option value="organic_search">Busca Orgânica</option>
            <option value="paid_ads">Anúncios Pagos</option>
          </select>
        </div>

        {/* Inactivity selector */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sem contato há
          </label>
          <select
            value={filters.noContactDays || ''}
            onChange={(e) => handleFilterChange('noContactDays', e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="">Qualquer</option>
            <option value="7">7+ dias</option>
            <option value="14">14+ dias</option>
            <option value="30">30+ dias</option>
          </select>
        </div>
      </div>

      {/* Date range chips */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Criado em
        </label>
        <div className="flex flex-wrap gap-2">
          {DATE_SHORTCUTS.map((s) => {
            const active = (s.key === 'all' && !filters.createdFrom)
              || (s.key !== 'all' && filters.createdFrom === dateShortcutToCreatedFrom(s.key));
            return (
              <button
                key={s.key}
                type="button"
                onClick={() => handleFilterChange('createdFrom', dateShortcutToCreatedFrom(s.key))}
                className={`px-3 py-1 rounded-full text-sm border ${
                  active ? 'bg-blue-50 border-blue-300 text-blue-700' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
                }`}
              >
                {s.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Ordenar — visible para todos los roles */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Ordenar por
          </label>
          <select
            value={`${filters.sortBy}-${filters.sortOrder}`}
            onChange={(e) => {
              const [sortBy, sortOrder] = e.target.value.split('-');
              onFilterChange({ sortBy, sortOrder });
            }}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="created_at-DESC">Mais Recente</option>
            <option value="created_at-ASC">Mais Antigo</option>
            <option value="lead_score-DESC">Maior Score</option>
            <option value="lead_score-ASC">Menor Score</option>
          </select>
        </div>
      </div>

      {/* Proprietário — solo managers/admin */}
      {(userRole === 'administrator' || userRole === 'Super_Admin' || userRole === 'Admin_Marketing') && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Proprietário
            </label>
            <select
              value={filters.ownerId || ''}
              onChange={(e) => handleFilterChange('ownerId', e.target.value)}
              className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            >
              <option value="">Todos</option>
              <option value="francielle">Francielle</option>
              <option value="luiza">Luiza</option>
              <option value="ryan">Ryan</option>
              <option value="rui">Rui</option>
            </select>
          </div>
        </div>
      )}

      {/* Archived toggle */}
      <div className="flex items-center">
        <input
          id="archivedOnly"
          type="checkbox"
          checked={!!filters.archivedOnly}
          onChange={(e) => handleFilterChange('archivedOnly', e.target.checked)}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        />
        <label htmlFor="archivedOnly" className="ml-2 text-sm text-gray-700">
          Mostrar arquivados
        </label>
      </div>

      {/* Clear filters button */}
      <div className="flex justify-end">
        <button
          onClick={() => onFilterChange({
            lifecycleStage: '',
            leadStatus: '',
            minScore: '',
            maxScore: '',
            ownerId: '',
            leadSource: '',
            createdFrom: '',
            noContactDays: '',
            archivedOnly: false,
            sortBy: 'created_at',
            sortOrder: 'DESC',
          })}
          className="text-sm text-gray-600 hover:text-gray-900"
        >
          Limpar Filtros
        </button>
      </div>
    </div>
  );
};

export default LeadFilters;
